// test1362
(1362 && 0);
